(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-slider"] && !window.DesignMode) return;
  try {
    
  window.addEventListener("load",()=>{
    // console.log("wqeqwewq");
    let reviewText = document.querySelectorAll('#yotpo-category-stars .text-m');
    for(let i of reviewText){
     let reviews = i.innerText;
      let result = reviews.slice(0, reviews.indexOf(' '));
      // console.log(result);
      i.innerText = `(${result})`;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
